import React, { useState, useEffect } from "react"
import { Space } from "antd"

const CardLink = ({ link }) => {
  return (
    <>
      <div className="card-link">
        <a href={link.link}>
          <div
            style={{
              margin: "20px 20px 0px 20px",
              padding: "20px 20px 0px 20px",
            }}
          >
            <Space style={{ marginBottom: 15 }}>
              <img src={link.icon} />
              <div className="card-title-font">{link.title}</div>
            </Space>
            <div className="text-font" style={{ textAlign: "left" }}>
              <p>{link.text}</p>
            </div>
          </div>
        </a>
      </div>
    </>
  )
}

export default CardLink
